export default {
  apiKeyTest: 'working',
  openWeatherMapApi: '123652873b5489fcb3e68c4d9c98a78f',
  unsplashApi: 'V8_Yy2IBu90rfZ77cYFLM2MFLS8h09Szdcv6XHaO19c'
}


// WEBPACK FOOTER //
// ./src/secure/index.js